/**
 * Do not edit directly, this file was auto-generated.
 */

import { css } from 'styled-components';
export const cssVariables = css``;
export const theme = {
  'surface/surface0': 'var(--mlb-2-1-0-color-neutral-neutral100, #f4f5f6)',
  'surface/surface1': 'var(--mlb-2-1-0-color-white, #ffffff)',
  'surface/surface2': 'var(--mlb-2-1-0-color-white, #ffffff)',
  'background/neutral': 'var(--mlb-2-1-0-color-neutral-neutral100, #f4f5f6)',
  'background/inverse': 'var(--mlb-2-1-0-color-neutral-neutral1400, #070a0d)',
  'background/emphasis-subtle': 'rgba(0, 72, 199, var(--mlb-2-1-0-opacity-opacity5, 0.05))',
  'background/emphasis-bold': 'var(--mlb-2-1-0-color-blue-blue700, #0048c7)',
  'background/alert': 'var(--mlb-2-1-0-color-red-red100, #ffd8d4)',
  'background/positive': 'var(--mlb-2-1-0-color-green-green100, #d4edd3)',
  'background/warning': 'var(--mlb-2-1-0-color-yellow-yellow100, #f7e0c8)',
  'border/neutral-decorative': 'var(--mlb-2-1-0-color-neutral-neutral200, #e8eaed)',
  'border/neutral-contrast': 'var(--mlb-2-1-0-color-neutral-neutral700, #7f8994)',
  'border/inverse': 'var(--mlb-2-1-0-color-neutral-neutral1400, #070a0d)',
  'border/emphasis': 'var(--mlb-2-1-0-color-blue-blue700, #0048c7)',
  'border/alert': 'var(--mlb-2-1-0-color-red-red700, #aa0013)',
  'border/positive': 'var(--mlb-2-1-0-color-green-green700, #006c00)',
  'text/primary': 'var(--mlb-2-1-0-color-neutral-neutral1400, #070a0d)',
  'text/secondary': 'var(--mlb-2-1-0-color-neutral-neutral900, #57606c)',
  'text/inverse': 'var(--mlb-2-1-0-color-white, #ffffff)',
  'text/action': 'var(--mlb-2-1-0-color-blue-blue700, #0048c7)',
  'text/alert': 'var(--mlb-2-1-0-color-red-red700, #aa0013)',
  'text/positive': 'var(--mlb-2-1-0-color-green-green700, #006c00)',
  'text/warning': 'var(--mlb-2-1-0-color-yellow-yellow700, #8c3c00)',
  'icon/primary': 'var(--mlb-2-1-0-color-neutral-neutral1300, #14191f)',
  'icon/secondary': 'var(--mlb-2-1-0-color-neutral-neutral900, #57606c)',
  'icon/decorative': 'var(--mlb-2-1-0-color-neutral-neutral700, #7f8994)',
  'icon/inverse': 'var(--mlb-2-1-0-color-white, #ffffff)',
  'icon/action': 'var(--mlb-2-1-0-color-blue-blue700, #0048c7)',
  'icon/alert': 'var(--mlb-2-1-0-color-red-red700, #aa0013)',
  'icon/positive': 'var(--mlb-2-1-0-color-green-green700, #006c00)',
  'icon/warning': 'var(--mlb-2-1-0-color-yellow-yellow700, #8c3c00)',
  'static/black': 'var(--mlb-2-1-0-color-black, #000000)',
  'static/white': 'var(--mlb-2-1-0-color-white, #ffffff)',
  'static/border/highlight': 'rgba(255, 255, 255, var(--mlb-2-1-0-opacity-opacity20, 0.2))',
  'static/overlay/default': 'rgba(0, 0, 0, var(--mlb-2-1-0-opacity-opacity40, 0.4))',
  'static/overlay/bold': 'rgba(0, 0, 0, var(--mlb-2-1-0-opacity-opacity70, 0.7))',
  'static/background/action': 'var(--mlb-2-1-0-color-blue-blue700, #0048c7)',
  'static/background/alert': 'var(--mlb-2-1-0-color-red-red700, #aa0013)',
  'static/accent/blue-light': 'var(--mlb-2-1-0-color-blue-blue200, #a4cdff)',
  'static/accent/blue-dark': 'var(--mlb-2-1-0-color-blue-blue600, #0062e3)',
  'static/accent/red-light': 'var(--mlb-2-1-0-color-red-red200, #ffb3ad)',
  'static/accent/red-dark': 'var(--mlb-2-1-0-color-red-red600, #c61b2b)',
  'static/accent/green-light': 'var(--mlb-2-1-0-color-green-green200, #acdaa9)',
  'static/accent/green-dark': 'var(--mlb-2-1-0-color-green-green600, #098314)',
  'static/accent/yellow-light': 'var(--mlb-2-1-0-color-yellow-yellow200, #edc394)',
  'static/accent/yellow-dark': 'var(--mlb-2-1-0-color-yellow-yellow600, #a65400)',
  'static/accent/purple-light': 'var(--mlb-2-1-0-color-purple-purple200, #d0c2f3)',
  'static/accent/purple-dark': 'var(--mlb-2-1-0-color-purple-purple600, #7756b3)',
  'state/hover': 'rgba(7, 10, 13, var(--mlb-2-1-0-opacity-opacity5, 0.05))',
  'state/pressed': 'rgba(7, 10, 13, var(--mlb-2-1-0-opacity-opacity10, 0.10))',
  'state/skeleton-background': 'var(--mlb-2-1-0-color-neutral-neutral300, #dbdfe3)',
  'state/skeleton-overlay': 'var(--mlb-2-1-0-color-neutral-neutral400, #c3c8cf)',
  'shadow/shadow-small/blur': '16px',
  'shadow/shadow-small/spread': '0',
  'shadow/shadow-small/color': 'rgba(0,0,0,0.08)',
  'shadow/shadow-small/type': 'dropShadow',
  'shadow/shadow-small/offsetX': '0',
  'shadow/shadow-small/offsetY': '0',
  'shadow/shadow-medium/blur': '24px',
  'shadow/shadow-medium/spread': '0',
  'shadow/shadow-medium/color': 'rgba(0,0,0,0.08)',
  'shadow/shadow-medium/type': 'dropShadow',
  'shadow/shadow-medium/offsetX': '0',
  'shadow/shadow-medium/offsetY': '1px',
  'shadow/shadow-large/blur': '32px',
  'shadow/shadow-large/spread': '0',
  'shadow/shadow-large/color': 'rgba(0,0,0,0.08)',
  'shadow/shadow-large/type': 'dropShadow',
  'shadow/shadow-large/offsetX': '0',
  'shadow/shadow-large/offsetY': '10px',
  'gradient/fade-subtle-start': 'var(--mlb-2-1-0-color-neutral-neutral100, #f4f5f6)',
  'gradient/fade-subtle-end': 'rgba(244, 245, 246, 0)',
  'gradient/fade-subtle':
    'linear-gradient(var(--mlb-2-1-0-gradient-fade-subtle-start, #f4f5f6) 0%, var(--mlb-2-1-0-gradient-fade-subtle-end, rgba(244, 245, 246, 0)) 100%)',
  'gradient/fade-subtle-90':
    'linear-gradient(90deg, var(--mlb-2-1-0-gradient-fade-subtle-start, #f4f5f6) 0%, var(--mlb-2-1-0-gradient-fade-subtle-end, rgba(244, 245, 246, 0)) 100%)',
  'gradient/fade-subtle-180':
    'linear-gradient(180deg, var(--mlb-2-1-0-gradient-fade-subtle-start, #f4f5f6) 0%, var(--mlb-2-1-0-gradient-fade-subtle-end, rgba(244, 245, 246, 0)) 100%)',
  'gradient/fade-subtle-270':
    'linear-gradient(270deg, var(--mlb-2-1-0-gradient-fade-subtle-start, #f4f5f6) 0%, var(--mlb-2-1-0-gradient-fade-subtle-end, rgba(244, 245, 246, 0)) 100%)',
};
